import React, { useState } from "react";
import t from "../../../helpers/t";
import FormItem from "../../../components/FormItem";
import { markdownToHTML } from "markdown-transform-html/dist/esm/markdown-transform-html.esm";
import "markdown-transform-html/lib/styles/index.css";
import { ADJUSTMENT_HELP_TEXT, HtmlTooltip } from "../../../../utils/HelperOld";

const GeneralSettings = (props) => {
  const { onChange, setting, client } = props;
  const paymentMethods = [
    { id: "paypalAgreement", name: t("paypal") },
    { id: "stripeSISDKCC", name: t("credit_card") },
    { id: "stripeSepa", name: t("sepa") },
    { id: "applePay", name: t("ApplePay") },
    { id: "googlePay", name: t("GooglePay") },
    { id: "cartVoucher", name: t("cart_voucher") },
    { id: "cartItemVoucher", name: t("cart_item_voucher") },
  ];
  const [selectedItems, setSelectedItems] = useState(function () {
    let sel = [];
    if (client.payment_methods !== null) {
      let t = client.payment_methods.split(",");
      let pMethods = {};
      paymentMethods.map((p) => {
        pMethods[p.id] = p.name;
      });
      if (t.length > 0) {
        t.map((st) => {
          sel.push({ id: st, name: pMethods[st] });
        });
      }
    }
    return sel;
  });

  const triggerOnChange = () => {
    onChange({ result: selectedItems }, "payment_methods");
  };

  const fontFamilies = [
    { name: "Helvetica" },
    { name: "Arial" },
    { name: "Arial Black" },
    { name: "Verdana" },
    { name: "Tahoma" },
    { name: "Trebuchet MS" },
    { name: "Impact" },
    { name: "Gill Sans" },
    { name: "Times New Roman" },
    { name: "Georgia" },
    { name: "Palatino" },
    { name: "Baskerville" },
    { name: "Andalé Mono" },
    { name: "Courier" },
    { name: "Lucida" },
    { name: "Monaco" },
    { name: "Bradley Hand" },
    { name: "Brush Script MT" },
    { name: "Luminari" },
    { name: "Comic Sans MS" },
  ];
  return (
    <>
      <fieldset className="fieldBox" style={{ width: "98%" }}>
        <label className="inb-form__controlLabel legendLabel">
          <span>&nbsp;</span>
        </label>
        <div className="row medium-12 small-12">
          <FormItem
            type="input"
            value={client.organization}
            id={client.organization}
            name="organization"
            label={t("organization")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
          <FormItem
            type="input"
            value={setting.display_name}
            id={setting.display_name}
            name="display_name"
            label={t("display name")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
        </div>
        <div className="row medium-12 small-12">
          <FormItem
            type="input"
            value={client.email}
            id={client.email}
            name="email"
            label={t("email")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
          <FormItem
            type="input"
            value={client.url}
            id={client.url}
            name="url"
            label={t("url")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
        </div>
        <div className="row medium-12 small-12">
          <FormItem
            type="input"
            value={client.street}
            id={client.street}
            name="street"
            label={t("street")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
          <FormItem
            type="input"
            value={client.number}
            id={client.number}
            name="number"
            label={t("house_nbr")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
        </div>
        <div className="row medium-12 small-12">
          <FormItem
            type="input"
            value={client.zip}
            id={client.zip}
            name="zip"
            label={t("zip")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
          <FormItem
            type="input"
            value={client.city}
            id={client.city}
            name="city"
            label={t("city")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
        </div>
        <div className="row medium-12 small-12">
          <FormItem
            type="input"
            value={client.phone}
            id={client.phone}
            name="phone"
            label={t("phone_nbr")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
        </div>
        <div className="row medium-12 small-12">
          <FormItem
            type="input"
            value={client.ust_id}
            id={client.ust_id}
            name="ust_id"
            label={t("ust_id")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
          <FormItem
            type="input"
            value={client.currency}
            id={client.currency}
            name="currency"
            label={t("currency")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
        </div>
        <div className="row medium-12 small-12">
          <FormItem
            type="checkbox"
            value={client.is_public}
            id={client.id}
            name="is_public"
            label={t("is_public")}
            labelStyle={{ minWidth: "230px" }}
            htmlFor={t("is_public")}
            mediumWidth="12"
            smallWidth="12"
            onChangeHandler={onChange}
          />
          <FormItem
            type="input"
            value={setting.product}
            id={setting.product}
            name="product"
            label={t("product")}
            labelStyle={{ minWidth: "120px", float: "left" }}
            inputStyle={{ maxWidth: "250px", minWidth: "250px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="text"
          />
          <FormItem
            type="time-input"
            value={setting.tokenDuration}
            id={setting.id}
            name="tokenDuration"
            label={t("token duration")}
            labelStyle={{}}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            unit="seconds"
            big={true}
            extraTopClasses="float-left width100"
          />
        </div>
        <div className="row medium-12 small-12">
          <FormItem
            type="multiSelect"
            value={client.payment_methods !== null ? client.payment_methods.split(",") : null}
            id={setting.id}
            name="payment_methods"
            label={
              t("payment settings") +
              " (" +
              t("leave it empty for all payment methods (without voucher, googlePay, applePay)") +
              ")"
            }
            labelStyle={{ minWidth: "120px", float: "left", marginLeft: "15px" }}
            selectStyle={{ width: "50%" }}
            data={paymentMethods}
            placeholder={t(
              "leave it empty for all payment methods (without voucher, googlePay, applePay)",
            )}
            valkey="id"
            valprop="name"
            mediumWidth="6"
            smallWidth="12"
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            triggerOnChange={triggerOnChange}
          />
        </div>
      </fieldset>
      <fieldset className="fieldBox" style={{ width: "98%" }}>
        <label className="inb-form__controlLabel legendLabel">
          {" "}
          <HtmlTooltip
            title={
              <React.Fragment>
                {
                  <ADJUSTMENT_HELP_TEXT
                    content={
                      t("Einstellung Farben", null, "capital") + "::" + t("colors_info") + "//"
                    }
                  />
                }
              </React.Fragment>
            }
          >
            <a>
              <i className="inb-ico fi fi-info"> {t("info", null, "capital")}</i>
            </a>
          </HtmlTooltip>
        </label>
        <div className="row medium-12 small-12">
          <FormItem
            type="input"
            value={setting.primaryColor}
            id={setting.id}
            name="primaryColor"
            label={t("primary color")}
            labelStyle={{ marginRight: "30px", float: "left" }}
            inputStyle={{ maxWidth: "60px", minWidth: "50px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="color"
          />
          <FormItem
            type="input"
            value={setting.secondaryColor}
            id={setting.id}
            name="secondaryColor"
            label={t("secondary color")}
            labelStyle={{ marginRight: "30px", float: "left" }}
            inputStyle={{ maxWidth: "60px", minWidth: "50px" }}
            mediumWidth="6"
            smallWidth="12"
            onChangeHandler={onChange}
            inputType="color"
          />
        </div>
      </fieldset>
      {/*  <fieldset className='fieldBox' style={{width:"98%", minHeight:"170px"}}>
                <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                         onClick={(e) => _showPopUp(e, 'font')}><i
                    className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>
                    <div className="row medium-12 small-12">
                    <FormItem
                        type='select'
                        value={setting.font}
                        id={setting.id}
                        name='font'
                        label={t('font')}
                        labelStyle={{marginRight:'30px',float:'left',marginLeft:"20px"}}
                        selectStyle={{width:"50%"}}
                        data={fontFamilies}
                        dataKey="name"
                        mediumWidth="6"
                        smallWidth="12"
                        onChangeHandler={onChange}
                        />
                    <FormItem
                        type='input'
                        value={setting.fontSize}
                        id={setting.id}
                        name='fontSize'
                        label={t('font-size')}
                        labelStyle={{marginRight:'30px',float:'left'}}
                        inputStyle={{maxWidth:"60px",minWidth:"50px"}}
                        mediumWidth="6"
                        smallWidth="12"
                        onChangeHandler={onChange}
                        inputType="number"
                    />
                    </div>
                </fieldset>*/}
      <div className="fieldBox" style={{ width: "98%" }}>
        <label className="inb-form__controlLabel legendLabel">
          <HtmlTooltip
            title={
              <React.Fragment>
                {
                  <ADJUSTMENT_HELP_TEXT
                    content={
                      t("Nutzungsbedingungen", null, "capital") + "::" + t("agb_info") + "//"
                    }
                  />
                }
              </React.Fragment>
            }
          >
            <a>
              <i className="inb-ico fi fi-info"> {t("info", null, "capital")}</i>
            </a>
          </HtmlTooltip>
        </label>
        <div className="row medium-12 small-12" style={{ margin: "5px" }}>
          <FormItem
            type="editor"
            value={client.agb !== null ? markdownToHTML(client.agb) : ""}
            id={client.id.toString() + "_agb"}
            name="agb"
            label={t("agb")}
            readOnly={false}
            mediumWidth="12"
            smallWidth="12"
            onChangeHandler={onChange}
            theme="snow"
          />
        </div>
      </div>
      <div className="fieldBox" style={{ width: "98%" }}>
        <label className="inb-form__controlLabel legendLabel">
          <HtmlTooltip
            title={
              <React.Fragment>
                {
                  <ADJUSTMENT_HELP_TEXT
                    content={t("Hilfe", null, "capital") + "::" + t("help_info") + "//"}
                  />
                }
              </React.Fragment>
            }
          >
            <a>
              <i className="inb-ico fi fi-info"> {t("info", null, "capital")}</i>
            </a>
          </HtmlTooltip>
        </label>

        <div className="row medium-12 small-12 bigText" style={{ margin: "5px" }}>
          <FormItem
            type="editor"
            value={client.help !== null ? markdownToHTML(client.help).replace("####", "") : ""}
            id={client.id.toString() + "_help"}
            name="help"
            label={t("help")}
            readOnly={false}
            mediumWidth="12"
            smallWidth="12"
            onChangeHandler={onChange}
            theme="snow"
          />
        </div>
      </div>
    </>
  );
};

export default GeneralSettings;
